import { evaluationRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const evaluationRoute: RouteObject = {
  path: evaluationRoutePaths.evaluation.path,
  async lazy() {
    const EvaluationPage = await import('@/pages/evaluation/EvaluationPage');
    return { Component: EvaluationPage.default };
  },
};
